<template>
  <v-card>
    <v-card-title primary-title class="warning lighten-2">
      {{ label }}
    </v-card-title>
    <v-card-text class="pt-2">
      <!-- {{ $store.getters.get_PersonalDoc }} -->
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-center">แนปเอกสาร</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <v-row>
                  <v-col cols="3" class="d-flex align-center" v-if="$store.state.dataFrm.fileFromLoad.file_people_card!=''">
                    <v-btn
                    block
                      large
                      target="_blank"
                      color="primary"
                      :href="pathApp+'/file_doc/'+$store.state.dataFrm.fileFromLoad.file_people_card"
                      ><v-icon left>mdi-file-pdf-box</v-icon>เอกสารเดิม</v-btn
                    >
                  </v-col>
                  <v-col :cols="$store.state.dataFrm.fileFromLoad.file_people_card!=''?9:12">
                    <v-file-input
                      accept=".pdf"
                      label="สำเนาบัตรประจำตัวประชาชน"
                      show-size
                      v-model="$store.state.dataFrm.file_people_card"
                    ></v-file-input>
                  </v-col>
                </v-row>
              </td>
            </tr>
            <tr>
              <td>
                <v-row>
                  <v-col cols="3" class="d-flex align-center" v-if="$store.state.dataFrm.fileFromLoad.file_transcrip_tree!=''">
                    <v-btn
                    block
                      large
                      target="_blank"
                      color="primary"
                      :href="pathApp+'/file_doc/'+$store.state.dataFrm.fileFromLoad.file_transcrip_tree"
                      ><v-icon left>mdi-file-pdf-box</v-icon>เอกสารเดิม</v-btn
                    >
                  </v-col>
                  <v-col :cols="$store.state.dataFrm.fileFromLoad.file_transcrip_tree!=''?9:12">
                    <!-- {{ $store.state.dataFrm.fileFromLoad.file_transcrip_tree }} -->
                    <v-file-input
                      accept=".pdf"
                      label="สำเนาใบรายงานผลการศึกษา (ป.ตรี)"
                      show-size
                      v-model="$store.state.dataFrm.file_transcrip_tree"
                    ></v-file-input> </v-col
                ></v-row>
              </td>
            </tr>
            <tr>
              <td>
                <v-row>
                  <v-col cols="3" class="d-flex align-center" v-if="$store.state.dataFrm.fileFromLoad.file_transcrip_pvs!=''">
                    <v-btn
                    block
                      large
                      target="_blank"
                      color="primary"
                      :href="pathApp+'/file_doc/'+$store.state.dataFrm.fileFromLoad.file_transcrip_pvs"
                      ><v-icon left>mdi-file-pdf-box</v-icon>เอกสารเดิม</v-btn
                    >
                  </v-col>
                  <v-col :cols="$store.state.dataFrm.fileFromLoad.file_transcrip_pvs!=''?9:12">
                    <!-- {{ $store.state.dataFrm.fileFromLoad.file_transcrip_pvs }} -->
                    <v-file-input
                      accept=".pdf"
                      label="สำเนาใบรายงานผลการศึกษา (ปวส.)"
                      show-size
                      v-model="$store.state.dataFrm.file_transcrip_pvs"
                    ></v-file-input>
                  </v-col>
                </v-row>
              </td>
            </tr>
            <tr>
              <td>
                <v-row>
                  <v-col cols="3" class="d-flex align-center" v-if="$store.state.dataFrm.fileFromLoad.file_other!=''">
                    <v-btn
                    block
                      large
                      target="_blank"
                      color="primary"
                      :href="pathApp+'/file_doc/'+$store.state.dataFrm.fileFromLoad.file_other"
                      ><v-icon left>mdi-file-pdf-box</v-icon>เอกสารเดิม</v-btn
                    >
                  </v-col>
                  <v-col :cols="$store.state.dataFrm.fileFromLoad.file_other!=''?9:12">
                    <v-file-input
                      accept=".pdf"
                      label="เอกสารอื่นๆ"
                      show-size
                      v-model="$store.state.dataFrm.file_other"
                    ></v-file-input>
                  </v-col>
                </v-row>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
      <!-- {{$store.state.dataFrm.file_people_card}} -->
    </v-card-text>
  </v-card>
</template>
<script>
// import datetimepicker_TH from "./datetimepickerTH";
export default {
  data() {
    return {
      tea_doc: {
        doc_id: Array(),
        doc_name: Array(),
        doc_file: Object(),
      },
    pathApp:process.env.VUE_APP_PATHAPP
    };
  },
  components: {
    // datetimepicker_TH,
  },
  props: {
    label: {
      type: String,
      default: "",
    },
  },
  computed: {},
};
</script>
<style scoped>
.flex-center {
  display: flex;
  justify-content: center;
}
</style>
